const SUPPORTED_WIRE_COUNTRIES = [
  {
    name: 'United States of America',
    abbreviation: 'US',
    wireTemplate: 'US',
  },
  {
    name: 'Canada',
    abbreviation: 'CA',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Argentina',
    abbreviation: 'AR',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Australia',
    abbreviation: 'AU',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Austria',
    abbreviation: 'AT',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Belgium',
    abbreviation: 'BE',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Brazil',
    abbreviation: 'BR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Bulgaria',
    abbreviation: 'BG',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Chile',
    abbreviation: 'CL',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'China',
    abbreviation: 'CN',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Colombia',
    abbreviation: 'CO',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Costa Rica',
    abbreviation: 'CR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Croatia',
    abbreviation: 'HR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Cyprus',
    abbreviation: 'CY',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Czech Republic',
    abbreviation: 'CZ',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Denmark',
    abbreviation: 'DK',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Estonia',
    abbreviation: 'EE',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Finland',
    abbreviation: 'FI',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'France',
    abbreviation: 'FR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Germany',
    abbreviation: 'DE',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Greece',
    abbreviation: 'GR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Hong Kong',
    abbreviation: 'HK',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Hungary',
    abbreviation: 'HU',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'India',
    abbreviation: 'IN',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Ireland',
    abbreviation: 'IE',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Israel',
    abbreviation: 'IL',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Italy',
    abbreviation: 'IT',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Japan',
    abbreviation: 'JP',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'South Korea',
    abbreviation: 'KR',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Lithuania',
    abbreviation: 'LT',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Luxembourg',
    abbreviation: 'LU',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Malaysia',
    abbreviation: 'MY',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Malta',
    abbreviation: 'MT',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Mexico',
    abbreviation: 'MX',
    wireTemplate: 'Swift-CLABE',
  },
  {
    name: 'Netherlands',
    abbreviation: 'NL',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'New Zealand',
    abbreviation: 'NZ',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Norway',
    abbreviation: 'NO',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Pakistan',
    abbreviation: 'PK',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Peru',
    abbreviation: 'PE',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Poland',
    abbreviation: 'PL',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Portugal',
    abbreviation: 'PT',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Romania',
    abbreviation: 'RO',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Singapore',
    abbreviation: 'SG',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Slovakia',
    abbreviation: 'SK',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Slovenia',
    abbreviation: 'SI',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'South Africa',
    abbreviation: 'ZA',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Spain',
    abbreviation: 'ES',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Sweden',
    abbreviation: 'SE',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Switzerland',
    abbreviation: 'CH',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Taiwan',
    abbreviation: 'TW',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Thailand',
    abbreviation: 'TH',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Turkey',
    abbreviation: 'TR',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'United Arab Emirates',
    abbreviation: 'AE',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'United Kingdom',
    abbreviation: 'GB',
    wireTemplate: 'Swift-IBAN',
  },
  {
    name: 'Uruguay',
    abbreviation: 'UY',
    wireTemplate: 'Swift-Gen',
  },
  {
    name: 'Vietnam',
    abbreviation: 'VN',
    wireTemplate: 'Swift-Gen',
  },
];

module.exports = {
  SUPPORTED_WIRE_COUNTRIES,
}
